"use strict";

window.FoG = window.FoG || {};

window.FoG.SignalLoadMore = (function($) {
  var cloneIdx = 0;
  var loadMoreDef;
  var $signalTemplate;
  var $loadMore;
  var $signalContainer;
  
  function onLoadMore(response) {
    loadMoreDef.loadingMore = false;

    // Loop through articles and create/populate/append the container element
    $.each(response.articles, function(dummyIdx, signal) {
      var $signal = $signalTemplate.clone().removeClass('cloneable');
      
      if (signal.thumb) {
        $signal.find('.signal__img').css('background-image', 'url("' + signal.thumb + '")');
      }

      $signal.find('.article__thumbLinkOverlay').attr('href', signal.permalink).attr('title', signal.title);
      
      $signal.find('.shareMenu__shareOptionList fa-twitter').attr('href', signal.twitterUrl);
      $signal.find('.shareMenu__shareOptionList fa-linkedin').attr('href', signal.liUrl);
      $signal.find('.shareMenu__shareOptionList fa-facebook-square').attr('href', signal.fbUrl);
      $signal.find('.shareMenu__shareOptionList fa-envelope').attr('href', signal.mailUrl);
      $signal.find('.simplefavorite-button').attr('data-postid', signal.id);
      
      var copyId = 'copy-loadmore-permalink-' + (cloneIdx++);
      $signal.find('.permalinkShareWidget__permalink').attr('id', copyId).text(signal.permalink);
      $signal.find('.permalinkShareWidget__dialogWrapper button').attr('data-clipboard-target', copyId);
      FoG.prepClipboard($('.permalinkShareWidget__dialogWrapper button'));
      
      if (signal.tag) {
        $signal.find('.postTag').text(signal.tag);
      }
      else {
        $signal.find('.postTag').remove();
      }
      
      $signal.find('.signal__text h3 a').attr('href', signal.permalink).text(signal.title);
      $signal.find('.postAuthor').text(signal.author);
      $signal.find('.postDate').attr('datetime', signal['date-iso']).text(signal['date-display']);
      
      var $comment = $signal.find('.signalWidget--comments a');
      var commentCount = signal.commentCount;
      $comment.find('.signalWidget__commentCount').text(signal.commentCount);
      $comment.find('.signalWidget__commentLabel').text(commentCount == 1 ? 'comment' : 'comments');

      $signalContainer.append($signal).masonry('appended', $signal);
    });

    
    window.setTimeout(() => $signalContainer.masonry(), 1000);
    
    loadMoreDef.hasMore = response.hasMore;
    loadMoreDef.nextOffset = response.nextOffset;

    if (!loadMoreDef.hasMore) {
      rmLoadMoreButton();
    }
  }
  
  function rmLoadMoreButton() {
    $loadMore.closest('.loadMore__buttonContainer').remove();
  }
  
  function loadMoreClicked() {
    if (!loadMoreDef.hasMore) { 
      rmLoadMoreButton();
      return;
    }
    
    if (loadMoreDef.loadingMore) { return; }
    loadMoreDef.loadingMore = true;
    
    var params = {
      offset: loadMoreDef.nextOffset
    }
    
    var fnResetLoadingMore = () => { loadMoreDef.loadingMore = false; }
    NA.Ajax.get('signal-loadMore', params, onLoadMore, fnResetLoadingMore);
  }
  
  function init(def) {
    loadMoreDef = def;
    $signalContainer = $(def.signalContainerSelector);
    $signalTemplate = $(def.signalTemplateSelector);
    $loadMore = $(def.loadMoreSelector);
    $loadMore.on('click', loadMoreClicked);
  }
  
  return {
    init:init
  };
})(jQuery);